import { getDay as h, addMonths as k, startOfMonth as O, addDays as y, getDate as M, endOfMonth as W, subMonths as x, startOfWeek as S, startOfDay as d, getMonth as p, isEqual as T } from "date-fns";
import { WEEK_START as F } from "./datepicker-constants.js";
const w = (t) => t ? new Date(t) : /* @__PURE__ */ new Date(), N = (t, e, n, s = null, a = null) => {
  const c = w(JSON.parse(JSON.stringify(t))), o = s ? d(s) : null, l = a ? d(a) : null, f = [];
  for (let i = 0; i < 7; i++) {
    const r = y(c, i), D = p(r) !== e, u = D || o && d(r) < o || l && d(r) > l;
    f.push({
      text: r.getDate(),
      value: r,
      currentMonth: !D,
      disabled: !!u,
      isFirstDayOfMonth: r.getDate() === 1 && !D,
      selected: n ? r.getDate() === n && !u : !1
    });
  }
  return f;
}, b = (t, e) => !t || !e ? !1 : T(t, e), I = (t, e, n, s = null, a = null, c = F) => {
  const o = [], l = w(new Date(e, t)), f = w(new Date(e, t + 1, 0)), r = S(l, { weekStartsOn: c }), D = (u) => {
    const g = N(u, t, n, s, a);
    if (o.push({ days: g }), !o[o.length - 1].days.some(
      (m) => b(m.value, f)
    )) {
      const m = y(u, 7);
      D(m);
    }
  };
  return D(r), o;
}, P = (t, e) => {
  const n = [1, 2, 3, 4, 5, 6, 7].map((c) => new Intl.DateTimeFormat(t, { weekday: "short", timeZone: "UTC" }).format(/* @__PURE__ */ new Date(`2017-01-0${c}T00:00:00+00:00`)).slice(0, 2)), s = n.slice(0, e), a = n.slice(e + 1, n.length);
  return [n[e]].concat(...a).concat(...s);
}, q = (t, e, n) => new Intl.DateTimeFormat(n, { month: e }).format(new Date(2e3, t, 1)), z = (t, e, n) => new Intl.DateTimeFormat(n, { dateStyle: e }).format(new Date(t)), C = (t) => {
  const e = new Date(t), n = h(e), s = k(e, 1), a = O(s), c = h(a), o = (n - c + 7) % 7, l = y(a, o);
  return M(l);
}, J = (t) => {
  const e = new Date(t), n = h(e);
  let a = W(x(e, 1));
  for (; h(a) !== n; )
    a = y(a, -1);
  return M(a);
};
export {
  C as calculateNextFocusDate,
  J as calculatePrevFocusDate,
  z as formatDate,
  q as formatMonth,
  I as getCalendarDays,
  P as getWeekDayNames
};
//# sourceMappingURL=utils.js.map
